<template>
  <div class="role-management">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         角色管理
       </h4>
     </template>
    <el-row :gutter="10">
      <el-col :sm="8" :xs="24">
        <role ref="role" @roleClick="roleClick"></role>
      </el-col>
      <el-col :sm="10" :xs="24">
        <menus :role="role" ref="menu" @menuClick="menuClick"></menus>
      </el-col>
      <el-col :sm="6" :xs="24">
        <permission
          :role="role"
          :menu="menu"
          ref="routePermission"
          type="1"
        ></permission>
        <permission
          :role="role"
          :menu="menu"
          ref="buttonPermission"
          type="2"
        ></permission>
      </el-col>
    </el-row>
  </div>
</template>


<script>
import Role from "./rolecomponents/Role";
import Menus from "./rolecomponents/Menu";
import Permission from "./rolecomponents/Permission";
export default {
  name: "Role-management",
  components: { Permission, Role, Menus },
  data() {
    return {
      role: undefined,
      menu: undefined
    };
  },
  methods: {
    roleClick(role) {
      this.role = role;
    },
    menuClick(menu) {
      this.menu = menu;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/sysmenu/role-management.vue